// Module
var code = `<div class="step-progress-container">
    <div class="progress-labels">
        {{#each labels :index}}
            <div class="step-label {{ index + 1 <= currentStep ? 'completed' : '' }} {{ index + 1 === currentStep ? 'active' : '' }}">
                {{ . }}
            </div>
        {{/each}}
    </div>
    <div class="progress-line-container">
        {{#each Array(numberOfSteps) :index}}
            <div class="progress-step {{ index + 1 <= currentStep ? 'completed' : '' }} {{ index + 1 === currentStep ? 'active' : '' }}">
                <div class="step-circle"></div>
            </div>
            {{#if index + 1 < numberOfSteps}}
                <div class="progress-line {{ index + 1 < currentStep ? 'completed' : '' }}"></div>
            {{/if}}
        {{/each}}
    </div>
</div>
`;
// Exports
export default code;